import { Icon } from '@iconify/react';
import React from 'react';

const socialLinks = [
  {
    icon: 'fa6-brands:youtube',
    href: 'https://www.youtube.com/@WarpSoftt',
    label: 'YouTube',
  },
  {
    icon: 'fa6-brands:discord',
    href: 'https://discord.gg/upbs5Unb5n',
    label: 'Discord',
  },
];

export default function Footer() {
  return (
    <footer
      className="cs_footer cs_bg_filed"
      style={{ backgroundImage: 'url(/images/footer_bg.jpeg)' }}
    >
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cs_footer_item text-center">
                <img
                  src="/images/logo_white.svg"
                  alt="WarpSoft Logo"
                  style={{ maxWidth: '200px', marginBottom: '20px' }}
                />
                <p>
                  Dedicated to creating cutting-edge solutions for gaming
                  automation and user experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_bottom_footer">
          <div className="cs_social_btns cs_style_1 text-center">
            {socialLinks.map((item, index) => (
              <a
                href={item.href}
                className="cs_center"
                key={index}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
              >
                <Icon icon={item.icon} fontSize="24px" />
              </a>
            ))}
          </div>
          <div className="text-center cs_copyright">
            Copyright © 2023 WarpSoft. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
